import { route, string } from 'react-router-typesafe-routes/dom'
export const BILLING_ROUTES = {
  perCompany: route('et/company/:companyId/billingModule', {
    params: { companyId: string().defined() },
  }),
  perCompanyMonth: route('et/company/:companyId/billingModule/month/:period', {
    params: { companyId: string().defined(), period: string().defined() },
  }),
}
